import styles from "./styles.module.css";

const DesktopOnly = () => {
  return (
    <div className={styles.textWrapper}>
      <h1>Please open this website from a desktop device.</h1>
    </div>
  );
};

export default DesktopOnly;
